<div class="cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-cg-0dot5">
    <div>
        <button
            type="button"
            class="cmps-cdk-p-0 cmps-cdk-border-radius-4px cmps-cdk-bg-color-transparent cmps-cdk-color-unknown-115 not:disabled:cmps-cdk-cursor-pointer cmps-cdk-border-width-0p focus:not:focus-visible:cmps-cdk-outline-0 hover:cmps-cdk-color-unknown-104"
            [cmpsTooltipTrigger]="
                area?.collapsedProTips ? 'Show Pro Tips' : 'Hide Pro Tips'
            "
            (click)="area.collapsedProTips = !area.collapsedProTips"
            *ngIf="area?.proTips?.length > 0"
        >
            <cmps-icon
                class="cmps-cdk-w-18px nested:cmps-cdk-w-inherit"
                svgIcon="lightbulb-outline"
            ></cmps-icon>
        </button>
    </div>
    <ng-container *ngIf="_state.phase?.live !== true">
        <div>
            <button
                type="button"
                class="cmps-cdk-p-0 cmps-cdk-border-radius-4px cmps-cdk-bg-color-transparent cmps-cdk-color-unknown-115 not:disabled:cmps-cdk-cursor-pointer not:disabled:hover:cmps-cdk-color-unknown-101 cmps-cdk-border-width-0p focus:not:focus-visible:cmps-cdk-outline-0"
                [disabled]="group.first === area"
                [cmpsTooltipTrigger]="'Move Up'"
                (click)="_onMoveUpClick()"
            >
                <cmps-icon
                    class="cmps-cdk-w-18px nested:cmps-cdk-w-inherit"
                    svgIcon="arrow-up"
                ></cmps-icon>
            </button>
        </div>
        <div>
            <button
                type="button"
                class="cmps-cdk-p-0 cmps-cdk-border-radius-4px cmps-cdk-bg-color-transparent cmps-cdk-color-unknown-115 not:disabled:cmps-cdk-cursor-pointer not:disabled:hover:cmps-cdk-color-unknown-101 cmps-cdk-border-width-0p focus:not:focus-visible:cmps-cdk-outline-0"
                [disabled]="group.last === area"
                [cmpsTooltipTrigger]="'Move Down'"
                (click)="_onMoveDownClick()"
            >
                <cmps-icon
                    class="cmps-cdk-w-18px nested:cmps-cdk-w-inherit"
                    svgIcon="arrow-down"
                ></cmps-icon>
            </button>
        </div>
        <div>
            <button
                type="button"
                class="cmps-cdk-p-0 cmps-cdk-border-radius-4px cmps-cdk-bg-color-transparent cmps-cdk-color-unknown-115 cmps-cdk-cursor-pointer hover:cmps-cdk-color-unknown-120 cmps-cdk-border-width-0p focus:not:focus-visible:cmps-cdk-outline-0"
                [cmpsTooltipTrigger]="'Remove'"
                (click)="_onDeleteClick()"
            >
                <cmps-icon
                    class="cmps-cdk-w-18px nested:cmps-cdk-w-inherit"
                    svgIcon="close"
                ></cmps-icon>
            </button>
        </div>
    </ng-container>
</div>
